import IHistoryDto from '@core/mappers/user/dtos/IHistoryDto';
import History, {
    TransactionStatus,
    TransactionType,
    CancelStatus,
    HistoryCategory,
} from '@models/user/history/History';
import {
    fillToUTCDate,
    toDate,
} from '@superbet-group/web.lib.utilities';

const TRANSACTION_WON_CLASS = 'green';
const CASINO_TRANSACTION_STATUS = 'Finished';

const getType = (dto: IHistoryDto) => {
    const name = dto.transactionName;
    if (name.indexOf('Retragere') === 0) {
        return TransactionType.withdrawal;
    }
    if (name.indexOf('Ajustare') === 0) {
        return TransactionType.manual;
    }
    if (name.indexOf('Depunere') === 0) {
        return TransactionType.deposit;
    }
    return TransactionType.other;
};

type HistoryMapperOptions = {
    isFetchable: boolean;
    category: HistoryCategory;
};

export function transformHistory(dto: IHistoryDto, options: HistoryMapperOptions): History {
    const history = {} as History;
    history.id = dto.transactionIdSec;
    history.date = toDate(fillToUTCDate(dto.dateTime));
    history.amount = dto.diff;
    // only casino transactions can be 'Finished'
    if (dto.status === CASINO_TRANSACTION_STATUS) {
        if (dto.colorClass === TRANSACTION_WON_CLASS) {
            history.status = TransactionStatus.won;
        } else {
            history.status = TransactionStatus.lost;
        }
    } else {
        history.status = dto.status as TransactionStatus;
    }
    history.isCancelable = dto.cancelTransaction;
    history.title = dto.transactionName;
    history.ticketId = dto.ticketId || '';
    history.type = getType(dto);
    history.category = options.category;
    history.transactionType = dto.type;
    history.credit = dto.credit;
    history.debit = dto.debit;
    history.gameName = dto.gameName;
    history.cancelStatus = CancelStatus.none;
    history.method = dto.method;
    history.isFetchable = options.isFetchable;
    return history;
}
